var _path, _line, _line2, _line3, _mask, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13C13.5523 2 14 2.44772 14 3V17C14 17.5523 13.5523 18 13 18H2C1.44772 18 1 17.5523 1 17V3C1 2.44772 1.44772 2 2 2H4",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 7.5,
    x2: 11,
    y2: 7.5,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10.5,
    x2: 11,
    y2: 10.5,
    stroke: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 13.5,
    x2: 8,
    y2: 13.5,
    stroke: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_9393_13283",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 7,
    height: 4,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 7,
    height: 4,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 3,
    mask: "url(#path-5-inside-1_9393_13283)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavActivity);
export default __webpack_public_path__ + "static/media/icon-nav-activity.9ac0c1fe91f9d277bf2904be7b9168e3.svg";
export { ForwardRef as ReactComponent };